import React from 'react';
import { PlusOutlined } from '@ant-design/icons';

export const AddAnotherCard = ({ text, handleClick }) => {
  return (
    <article className="add-another-card" onClick={() => handleClick()}>
      <span style={{color: '#1c64f2'}}>
        <PlusOutlined />
        {text}
      </span>
    </article>
  );
};
